import React, {
  forwardRef,
  useEffect,
  useImperativeHandle,
  useRef,
  useState,
} from "react";
import SearchPanel from "@widgets/SearchPanel";
import { fnGetDataSet } from "@shared/api/restApi";
import { getInitPopUp } from "@shared/utils/CommonUtils";
import { global } from "@shared/libs/Global";
import SnGrid from "@shared/components/Grid/SnGrid";
import SnTab from "@shared/components/SnTab";
import { showDialog } from "@widgets/CommonDialog";
import SnSearchBtn from "@shared/components/SnSearchBtn";
import SnLabel from "@shared/components/SnLabel";
import SnNumberBox from "@shared/components/SnNumberBox";

interface popupProps {
  selectedData?: any;
  modalRef?: any;
}

const SN_TRA_ELC_REG_001_POP_002 = forwardRef(
  ({ selectedData, modalRef }: popupProps, ref: React.Ref<any>) => {
    //#region variable
    const { userInfo } = global();
    const gridApiRef1 = useRef<any>(null); // 첫 번째  그리드 Reference 변수
    const gridApiRef2 = useRef<any>(null); // 두 번째  그리드 Reference 변수
    const searchRef = useRef<any>(null);
    //#endregion

    //#region Components useState
    const [formData, setFormData] = useState<any>();
    const [formControlData, setFormControlData] = useState<any[]>([]);

    const [columns1, setColums1] = useState<any[]>([]);
    const [columns2, setColums2] = useState<any[]>([]);

    const [dataSource1, setDataSource1] = useState<any[]>([]);
    const [dataSource2, setDataSource2] = useState<any[]>([]);

    const inputRefs = useRef<any>([]);

    const [gridFocus1, setGridFocus1] = useState(false);
    const [gridFocus2, setGridFocus2] = useState(false);
    //#endregion

    useImperativeHandle(ref, () => ({
      getSelectedRow: () => [
        gridApiRef1.current.getSelectedRows() || [],
        gridApiRef2.current.getCheckedRows() || [],
      ],
    }));

    useEffect(() => {
      const fetchform = async () => {
        try {
          const rtn: any = await getInitPopUp("SN_TRA_ELC_REG_001_POP_002", {});
          const mergedData: any = { ...rtn.formData, ...selectedData };
          setFormControlData(rtn.formControlData); // 조회조건 항목 설정

          setFormData(mergedData); // 조회조건 초기값
          setColums1(rtn.grid.grid1); // H그리드 항목 설정
          setColums2(rtn.grid.grid2); // L그리드 항목 설정
        } catch (error) {}
      };
      fetchform();
    }, [userInfo]);

    useEffect(() => {
      gridApiRef1.current.selectAndFocusRow(0);
      gridApiRef2.current.selectAndFocusRow(0);
      setGridFocus1(false);
      setGridFocus2(false);
    }, [gridFocus1, gridFocus2]);

    //#region Button Event
    const onSearch = () => {
      const fetchdatasource = async () => {
        try {
          const param = {
            id: "sn_tra_elc_reg_001_POP_002_01",
            params: searchRef.current.getFormdata(),
          };
          setDataSource1([]);
          setDataSource2([]);

          const data: any = await fnGetDataSet(param);

          setDataSource1(data[0]);
          setDataSource2(data[1]);

          if (data[0] && data[0].length > 0) {
            //const selectNoEst = data[0][0];
            await new Promise((resolve) => setTimeout(resolve, 50));

            setGridFocus1(true);
            setGridFocus2(true);
          }

          gridApiRef1.current?.selectAndFocusRow(0);
          gridApiRef2.current?.selectAndFocusRow(0);
          gridApiRef1.current.resetUpdate();
          gridApiRef2.current.resetUpdate();
        } catch (error: any) {
          showDialog("error", error.message);
        }
      };
      fetchdatasource();
    };
    //#endregion

    //#region Event Method
    const onFocusedRowChanged = (event: any) => {
      const selectedRow = event?.data || event;

      if (selectedRow) {
        const cd_so = selectedRow.cd_so;
        const cd_cust = selectedRow.cd_cust;
        const fg_money = selectedRow.fg_money;
        const cd_exch = selectedRow.cd_exch;
        gridApiRef2.current.applyFilters({
          cd_cust: cd_cust,
          cd_so: cd_so,
          fg_money: fg_money,
          cd_exch: cd_exch,
        });
        gridApiRef2.current.selectAndFocusRow(0);
      }
    };
    //#endregion

    //#region UI
    return (
      <div style={{ position: "relative" }}>
        <div>
          <SearchPanel
            ref={searchRef}
            data={formData}
            controls={formControlData}
            popupRef={ref}
          ></SearchPanel>
        </div>
        <div style={{ textAlign: "center" }}>
          <SnSearchBtn
            text={"조회"}
            onClick={onSearch}
            sx={{ width: 80, marginTop: 1.5 }}
            spinner={true}
          />
        </div>
        <div style={{ height: "28vh", marginTop: "10px" }}>
          <SnGrid
            ref={gridApiRef1}
            columnConfig={columns1}
            rowData={dataSource1}
            rowSelection="single"
            isEditable={false}
            enableAddRow={false}
            onFocusedRowChanged={onFocusedRowChanged}
          />

          <SnGrid
            ref={gridApiRef2}
            columnConfig={columns2}
            rowData={dataSource2}
            rowSelection="multiple"
            isEditable={false}
            enableAddRow={false}
            ischeckboxSelection={true}
          />
        </div>
      </div>
    );
    //#endregion
  }
);

export default SN_TRA_ELC_REG_001_POP_002;
